import { Button, Placeholder } from '@/shared/ui/primitives';
import type { FC } from 'react';

import { isAppError } from '@/shared/api';

interface QueryErrorPlaceholderProps {
  error?: unknown;
  onRetry?: () => void;
  header?: string;
}

const getErrorDescription = (error: unknown): string | undefined => {
  if (!isAppError(error)) return undefined;

  switch (error.kind) {
    case 'auth':
    case 'client':
      return error.message;
    case 'network':
      return 'You appear to be offline.';
    case 'timeout':
      return 'The request took too long. Try again.';
    case 'server':
      return 'Something went wrong on the server.';
    case 'cancelled':
      return undefined;
    case 'unknown':
    default:
      return undefined;
  }
};

export const QueryErrorPlaceholder: FC<QueryErrorPlaceholderProps> = ({
  error,
  onRetry,
  header = 'Could not load data',
}) => {
  const description = error !== undefined ? getErrorDescription(error) : undefined;

  return (
    <Placeholder
      title={header}
      description={description}
      action={
        onRetry ? (
          <Button variant="primary" fullWidth size="lg" onClick={onRetry}>
            Retry
          </Button>
        ) : undefined
      }
    />
  );
};
